import React, { useEffect, useState } from 'react';

// material-ui
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

// styles
import useStyles from './styles';

function DetectDevice() {
    const [countdown, setCountdown] = useState(10);
    const classes = useStyles();

    useEffect(() => {
        if (navigator.userAgent.match(/Android/i)) {
            const timer = setInterval(() => {
                setCountdown((countdown) => countdown - 1);
            }, 1000);

            return () => clearInterval(timer);
        }
    }, []);

    // function MobileDetect() {
    //     const toMatch = [
    //         /Android/i,
    //         /webOS/i,
    //         /iPhone/i,
    //         /iPad/i,
    //         /iPod/i,
    //         /BlackBerry/i,
    //         /Windows Phone/i
    //     ];

    //     return toMatch.some((toMatchItem) => {
    //         return navigator.userAgent.match(toMatchItem);
    //     });
    // }

    return (
        <>
            {navigator.userAgent.match(/Android/i)
                ?
                countdown === 0 ? (window.location.href = "https://play.google.com/store/apps/details?id=com.yosicsa.pemutakhiranpk") :
                    <Container maxWidth="xs">
                        {console.log("<<<<< DEVICE ANDA ANDROID >>>>>")}
                        <Paper className={classes.paper}>
                            <Typography variant="h6">Anda akan dialihkan ke halaman Play Store</Typography>
                            <br></br>
                            <Typography style={{ color: 'blue' }}>{countdown} detik</Typography>
                        </Paper>
                    </Container>
                :
                (
                    <>
                        {console.log("<<<<< DEVICE ANDA IOS >>>>>")}
                    </>
                )
            }
        </>
    )
}

export default DetectDevice;